(function (ws) {
    'use strict';
    ws.views.compRMAForm = ws.views.form.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'rma_activity',
        GTM_EVENT_ACTION: 'request rma step 1',
        /**
         * Initialize function
         */
        initialize: function () {
            ws.views.form.prototype.initialize.call(this);
            this.$additionalInfoField = this.$('textarea[name=additionalInfo]');
            this.$additionalInfoError = this.$('.rma-additional-error');
            this.$serialInfoError = this.$('.rma-serialInfo-error');
            this.$selectedCheckbox = this.$('.selectedCheckbox');
            this.$returnQuantities = this.$('.returnQuantities');
        },

        /**
         * Additional field validations
         */
        additionalValidation: function () {
            this.checkReturnQuantities();
            this.checkOtherDropdown();
        },

        /**
         * Check if return type is other for any dropdown
         */
        checkOtherDropdown: function () {
            this.$additionalInfoError.hide();
            var $returnReasonFields = this.$('select.returnReason');

            $.each($returnReasonFields, function (i, field) {
                if ($(field).val() === 'other') {
                    this.checkAdditionalInfoField();
                    return false;
                }
            }.bind(this));
        },

        /**
         * Check return quantities or serial numbers
         */
        checkReturnQuantities: function () {
            this.error = false;
            this.$serialInfoError.hide();

            //Checking number of qty input filled
            var filledTextbox = this.$returnQuantities.filter(function () {
                return $.trim($(this).val()) !== '';
            });

            //Checking is any product has serial numbers
            var serialNumbers = this.$selectedCheckbox.filter(function () {
                return $.trim($(this).val()) !== '';
            });

            //If no quantity and no serial numbers selected for any product, do not allow to proceed
            if (!filledTextbox.length && !serialNumbers.length) {
                this.error = true;
                this.$serialInfoError.show();

            //a filled quantity input found, perform some additional checks on it
            } else if (filledTextbox.length || serialNumbers.length) {
                if (filledTextbox.length) {
                    filledTextbox.each(function (index, el) {
                        var $el = $(el);
                        var qty = parseInt($el.closest('tbody tr').find('.qty-returnable').text());
                        this.checkDropdownsMandatory($el.closest('tbody tr'));

                        var qtyInput = ~~$el.val();
                        if (!_.isNumber(qtyInput) || parseInt(qtyInput) <= 0 || parseInt(qtyInput) > qty || isNaN(qtyInput)) {
                            $el.addClass('error');
                            this.$serialInfoError.show();
                            this.error = true;
                        }
                    }.bind(this));
                }

                if (serialNumbers.length) {
                    serialNumbers.each(function (index, el) {
                        this.checkDropdownsMandatory($(el).closest('tbody tr'));
                    }.bind(this));
                }
            }
        },

        /**
         * Check for mandatory dropdowns
         */
        checkDropdownsMandatory: function($ele) {
            if ([$ele.find('.returnReason').val(), $ele.find('.returnType').val(), $ele.find('.productCondition').val()].includes('')) {
                this.$serialInfoError.show();
                this.error = true;
            }
        },

        /**
         * Overriding submitForm and tracking Analytic event
         */
        submitForm() {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION);
            ws.views.form.prototype.submitForm.call(this);
        },

        /**
         * Check if additional info field is populated
         */
        checkAdditionalInfoField: function () {
            if (!$.trim(this.$additionalInfoField.val())) {
                this.$additionalInfoField.addClass('error');
                this.$additionalInfoError.show();
                this.error = true;
            }
        }
    });
})(westcon);
